import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
const defaultOptions = {} as const;

export type CreateContainerCargoItemMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.CreateContainerCargoItemInput;
}>;

export type CreateContainerCargoItemMutationResult = { __typename?: 'Mutation' } & {
  cargoCreateContainerCargoItem?: GraphQLTypes.Maybe<
    { __typename?: 'CreateContainerCargoItemPayload' } & {
      cargoItem?: GraphQLTypes.Maybe<
        | ({ __typename?: 'CargoContainerType' } & Pick<GraphQLTypes.CargoContainerType, 'id'>)
        | ({ __typename?: 'CargoLooseCargoType' } & Pick<GraphQLTypes.CargoLooseCargoType, 'id'>)
        | ({ __typename?: 'CargoVehicleType' } & Pick<GraphQLTypes.CargoVehicleType, 'id'>)
      >;
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const CreateContainerCargoItemDocument = /*#__PURE__*/ gql`
  mutation createContainerCargoItem($input: CreateContainerCargoItemInput!) {
    cargoCreateContainerCargoItem(input: $input) {
      cargoItem {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useCreateContainerCargoItemMutation__
 *
 * To run a mutation, you first call `useCreateContainerCargoItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContainerCargoItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContainerCargoItemMutation, { data, loading, error }] = useCreateContainerCargoItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContainerCargoItemMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateContainerCargoItemMutationResult, CreateContainerCargoItemMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<CreateContainerCargoItemMutationResult, CreateContainerCargoItemMutationVariables>(
    CreateContainerCargoItemDocument,
    options
  );
}
export type CreateContainerCargoItemMutationHookResult = ReturnType<typeof useCreateContainerCargoItemMutation>;
